import {Li, Ul} from '@/components/general'
import {BlueLinkButton} from '@/ui/app'
import {ArrowTopRightIcon} from '@sanity/icons'
import {Box, Flex, Heading, Stack, Text} from '@sanity/ui'
import React from 'react'

interface FunctionsSettingsProps {
  // Stub for adding props in the future
}

export const FunctionsSettings: React.FC<FunctionsSettingsProps> = () => {
  return (
    <Stack space={4}>
      <Box paddingTop={2}>
        <Heading size={2} as="h2">
          Functions
        </Heading>
      </Box>
      <Box>
        <Text size={2} muted as="p" style={{maxWidth: 600}}>
          Functions enable you to execute custom logic whenever changes occur in your content–all
          without requiring your own infrastructure.
          <br />
          With Functions, you can:
          <br />
          <Ul paddingTop={2}>
            <Li size={2}>Enrich, validate, and constrain your content in new ways.</Li>
            <Li size={2}>Create compute workflows.</Li>
            <Li size={2}>
              Connect changes in your content to external applications and services. Refresh a CDN
              cache, trigger social posts, update inventory, and more.
            </Li>
          </Ul>
        </Text>
      </Box>
      <Flex>
        <Box paddingTop={3} style={{marginLeft: '-0.75rem'}}>
          <BlueLinkButton
            icon={ArrowTopRightIcon}
            href={`https://www.sanity.io/docs/compute-and-ai/functions-introduction`}
            fontSize={1}
            target={'_blank'}
            text={'Learn more about Functions in Sanity Docs'}
            mode="bleed"
          />
        </Box>
      </Flex>
    </Stack>
  )
}
